import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import useWidth from "../hooks/useWidth";


const FooterComponent = () => {

    const breakpoints = useWidth();
    const isSmallScreen = useMediaQuery('(max-width:600px)');


    const [language, setLanguage] = useState("english");

    useEffect(() => {
        const storedLanguage = localStorage.getItem('language');

        if (storedLanguage) {
            setLanguage(storedLanguage);
        }
    }, []);


    const currentYear = new Date().getFullYear();

    const translations = {
        english: {
            year: `© ${currentYear}`,
            company: "Radix Group Incorporated.",
            allRightsReserved: "All Rights Reserved.",
            privacy: "Privacy",
            termsOfUse: "Terms of Use",
            dataProtection: "Data Protection",
            cookies: "Cookies",
            socialMedia: "Social Media"
        },
        korean: {
            year: `© ${currentYear}`,
            company: "Radix 그룹 주식회사.",
            allRightsReserved: "모든 권리 보유.",
            privacy: "개인정보 보호",
            termsOfUse: "이용 약관",
            dataProtection: "데이터 보호",
            cookies: "쿠키",
            socialMedia: "소셜 미디어"
        },
        spanish: {
            year: `© ${currentYear}`,
            company: "Radix Group Incorporated.",
            allRightsReserved: "Todos los derechos reservados.",
            privacy: "Privacidad",
            termsOfUse: "Términos de uso",
            dataProtection: "Protección de datos",
            cookies: "Cookies",
            socialMedia: "Redes sociales"
        }
    }


    return (
        <Box class="container">
            <Grid container sx={{ padding: 0 }}>
                <Grid item xs={12} sm={12} sx={{ padding: 0 }}>
                    <Grid container sx={{ padding: 0 }}>
                        <Grid item xs={12} sm={6} sx={{ textAlign: 'start', mt: breakpoints === 'xs' ? 1 : 0, pl: isSmallScreen ? 0 : 2 }}>
                            <Typography>{translations[language].year}&nbsp;{translations[language].company}&nbsp;{translations[language].allRightsReserved}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} sx={{ textAlign: isSmallScreen ? 'start' : 'end', mt: breakpoints === 'xs' ? 1 : 0, pr: isSmallScreen ? 0 : 2 }}>
                            <Typography>Contact us: +63 (32) 384-9309</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Box sx={{ mt: 2 }} />
        </Box>
    )
}

export default FooterComponent